import axios from 'axios'
import dayjs from 'dayjs'

/**
 * Before any API call, retrieve the clientID from the evnironmet to set the required X-IBM-Client-Id value
 **/
async function checkCredential(config) {
  if (!config.url.includes('apimanagerconsumercredentials')) {
    if (!window.api_credentials && !window.api_credentials_request) {
      window.api_credentials_request = axios
        .get('/portal/config/apimanagerconsumercredentials.json')
        .then(resp => (window.api_credentials = resp.data))
        .catch(err => console.log('Error fetching credentials ' + err))
    }
    await window.api_credentials_request
    config.headers.common['X-IBM-Client-Id'] = window.api_credentials?.clientId
  }

  return config
}

axios.interceptors.request.use(checkCredential)

export async function getEvolutiveByType(update) {
  let from = '2023-07-01T00:00:00Z'
  let to = dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
  if (update !== 'all') {
    let range = update.split(',')
    from = range[0]
    to = range[1]
  }
  let objectParams = {
    params: {
      from: from,
      to: to,
      slots: '',
    },
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'api/stats/evol/byType', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function getEvolutiveByThesaurus(update, lang) {
  let from = '2023-07-01T00:00:00Z'
  let to = dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
  if (update !== 'all') {
    let range = update.split(',')
    from = range[0]
    to = range[1]
  }
  let objectParams = {
    params: {
      from: from,
      to: to,
      slots: 50,
      language: lang,
    },
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'api/stats/evol/byThesaurus', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function getItemsViewed(update, types, search, page, itemsByPage, lang) {
  let from = '2023-07-01T00:00:00Z'
  let to = dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
  if (update !== 'all') {
    let range = update.split(',')
    from = range[0]
    to = range[1]
  }
  let objectParams = {
    params: {
      from: from,
      to: to,
      language: lang,
      start: (page - 1) * itemsByPage,
      rows: itemsByPage,
    },
  }
  if (types !== 'all') {
    objectParams.params.source = types
  }
  if (search) {
    objectParams.params.words = search
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'api/stats/rank/byItem', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function getItemsDownloaded(update, types, search, page, itemsByPage, lang) {
  let from = '2023-07-01T00:00:00Z'
  let to = dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
  if (update !== 'all') {
    let range = update.split(',')
    from = range[0]
    to = range[1]
  }
  let objectParams = {
    params: {
      from: from,
      to: to,
      language: lang,
      start: (page - 1) * itemsByPage,
      rows: itemsByPage,
    },
  }
  if (types !== 'all') {
    objectParams.params.source = types
  }
  if (search) {
    objectParams.params.words = search
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'api/stats/rank/byDownload', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function getSearchedWords(update, lang, search, page, itemsByPage) {
  let from = '2023-07-01T00:00:00Z'
  let to = dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
  if (update !== 'all') {
    let range = update.split(',')
    from = range[0]
    to = range[1]
  }
  let objectParams = {
    params: {
      from: from,
      to: to,
      language: lang,
      start: (page - 1) * itemsByPage,
      rows: itemsByPage,
    },
  }
  if (search) {
    objectParams.params.words = search
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'api/stats/rank/byWord', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function getCountryUsage(update, lang, page, itemsByPage) {
  let from = '2023-07-01T00:00:00Z'
  let to = dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
  if (update !== 'all') {
    let range = update.split(',')
    from = range[0]
    to = range[1]
  }
  let objectParams = {
    params: {
      from: from,
      to: to,
      language: lang,
      start: (page - 1) * itemsByPage,
      rows: itemsByPage,
    },
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'api/stats/rank/byCountry', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function getWebAccessChart(update) {
  let from = '2023-07-01T00:00:00Z'
  let to = dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
  if (update !== 'all') {
    let range = update.split(',')
    from = range[0]
    to = range[1]
  }
  let objectParams = {
    params: {
      from: from,
      to: to,
      slots: 50,
    },
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'api/stats/rank/byAccess', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function getWebRegistersChart(update) {
  let from = '2023-07-01T00:00:00Z'
  let to = dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
  if (update !== 'all') {
    let range = update.split(',')
    from = range[0]
    to = range[1]
  }
  let objectParams = {
    params: {
      from: from,
      to: to,
      slots: 50,
    },
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'api/stats/rank/byUser', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function getLangUseChart(update, lang) {
  let from = '2023-07-01T00:00:00Z'
  let to = dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
  if (update !== 'all') {
    let range = update.split(',')
    from = range[0]
    to = range[1]
  }
  let objectParams = {
    params: {
      from: from,
      to: to,
      language: lang,
    },
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'api/stats/rank/byLang', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function getDeviceUseChart(update, lang) {
  let from = '2023-07-01T00:00:00Z'
  let to = dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
  if (update !== 'all') {
    let range = update.split(',')
    from = range[0]
    to = range[1]
  }
  let objectParams = {
    params: {
      from: from,
      to: to,
      language: lang,
    },
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'api/stats/rank/byDevice', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function getHeatMapChart(update) {
  let from = '2023-07-01T00:00:00Z'
  let to = dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
  if (update !== 'all') {
    let range = update.split(',')
    from = range[0]
    to = range[1]
  }
  let objectParams = {
    params: {
      from: from,
      to: to,
    },
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'api/stats/rank/byTime', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}
